import React from 'react';
import classNames from 'classnames';

import './SellerDetailsCard.styles.scss';
import './SellerDetailsCard.styles.responsive.scss';

export type SellerDetailsRow = {
  label: string;
  value: React.ReactNode;
};

type SellerDetailsCardProps = {
  className?: string;
  title: string;
  note?: string;
  rows: SellerDetailsRow[];
  children?: React.ReactNode;
};

const SellerDetailsCard: React.FC<SellerDetailsCardProps> = (props) => {
  const { className, title, note, rows, children } = props;

  const classes = classNames('seller-details-card', className);

  return (
    <section className={classes}>
      <div className="seller-details-card__head">
        <h3>{title}</h3>
        {note && <span className="seller-details-card__note">{note}</span>}
      </div>

      <dl className="seller-details-card__rows">
        {rows.map(({ label, value }) => (
          <React.Fragment key={label}>
            <dt>{label}</dt>
            <dd>{value}</dd>
          </React.Fragment>
        ))}
      </dl>

      {children}
    </section>
  );
};

export default SellerDetailsCard;
